import React from 'react';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { Block, DefaultText, FlexRow, LogOutIcon } from '@guryou/html-components';
import { borderDefinition, smallBorderRadius } from '@guryou/html-theme';
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
  box: {
    transition: 'all 0.2s ease-in-out',
    '&:hover': {
      backgroundColor: '#f5f5f5',
    },
    cursor: 'pointer',
  },
  disabled: {
    backgroundColor: 'lightgray',
    color: 'gray',
    cursor: 'default !important',
  },
});

const SkipBlock = ({ title }) => {
  const classes = useStyles();
  const history = useHistory();
  const handleClick = () => {
    history.push('/management/providers');
  };

  return (
    <Block
      onClick={handleClick}
      className={classes.box}
      xs={12}
      margin={2}
      marginLeft={0.5}
      padding={4}
      border={borderDefinition()}
      borderRadius={smallBorderRadius}
    >
      <FlexRow margin={0} padding={0}>
        <Block xs={10}>
          <DefaultText fontWeight={800} textDecoration="underline" textUnderlineOffset="4px" color="#1A73E8">
            {title}
          </DefaultText>
        </Block>
        <Block xs={2} display="flex" flexDirection="row" alignItems="center" justifyContent="end">
          {<LogOutIcon fontSize="medium" htmlColor="#1A73E8" />}
        </Block>
      </FlexRow>
    </Block>
  );
};

export default SkipBlock;
